import { createApi } from '@reduxjs/toolkit/query/react';

import { z3xBaseQuery } from 'app/utils/api.utils';
import { IPageableResponse } from 'app/types/pageable-response';
import { ITokenFingerprint } from 'app/types/token-fingerprint.interface';
import { HydraApiResponse } from 'app/types/hydraData';

interface ITokenFingerprintGet {
  userCrd?: number;
  page?: number
  itemsPerPage?: number
}

export const tokenFingerprintApi = createApi({
  reducerPath: 'tokenFingerprints',
  baseQuery: z3xBaseQuery({ type: 'ld+json' }),
  endpoints: (builder) => ({
    getTokenFingerprints: builder.query<IPageableResponse<ITokenFingerprint>, ITokenFingerprintGet>({
      query: ( params ) => ({
        url: 'token-fingerprints',
        params: {
          ...params,
          'order[createdAt]': 'desc'
        },
      }),
      transformResponse: (response: HydraApiResponse<ITokenFingerprint[]>) => {
        return {
          items: response['hydra:member'],
          totalItems: response['hydra:totalItems']
        };
      }
    }),
  }),
});

export const {
  useGetTokenFingerprintsQuery,
  util: { resetApiState: tokenFingerprintsResetApiState },
} = tokenFingerprintApi;
